<app-print-ticket-type-dialog
  [orderId]="printOrderId"
  [orderItemIds]="printOrderItemIds"
  [seatIds]="printSeatIds"
  [subscriptionOrderIds]="printSubscriptionOrderIds"
  [printAction]="printAction"
  [ticketTypes]="ticketTypes()"
  [blockedTicketTypes]="blockedTicketTypes()"
  [productSeatCount]="productSeatCount()"
  [availabilityUnknown]="availabilityUnknown()"
  [selectionHasEvents]="hasEvents"
  [selectionHasSubscriptions]="hasSubscriptions"
  (detailedPrintClicked)="printOrder('detailed', $event.printType, $event.downloadType)"
  (directPrintClicked)="printOrder('direct', $event.printType, $event.downloadType)"
  (cancelSelectionClicked)="resetPrinting()"
>
</app-print-ticket-type-dialog>
@if (printType && printMode === 'detailed') {
<app-print-ticket-details-dialog
  [orderId]="printOrderId"
  [orderItemIds]="printOrderItemIds"
  [subscriptionOrderIds]="printSubscriptionOrderIds"
  [seatIds]="printSeatIds"
  [orderDisplayType]="printDisplayType"
  [printAction]="printAction"
  [printType]="printType"
  [customerEmail]="printCustomerEmail()"
  (beforeEmailClose)="onPrintSuccess()"
  (endActionsDetails)="$event ? onPrintSuccess() : resetPrinting()"
>
</app-print-ticket-details-dialog>
} @if (printType === ticketTypeEnum.Boca || printType === ticketTypeEnum.Card) {
<app-print-ticket-status-dialog
  [orderId]="printOrderId"
  [orderItemIds]="printOrderItemIds"
  [subscriptionOrderIds]="printSubscriptionOrderIds"
  [seatIds]="printSeatIds"
  [orderDisplayType]="printDisplayType"
  [printAction]="printAction"
  [printType]="printType"
  (beforePrintTicketStatusClose)="onPrintSuccess()"
></app-print-ticket-status-dialog>
}
